import { ICustomerGenericService, IHIPGenericService } from '@huge-monorepo/shared/interfaces';
import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChildren } from '@angular/core';
import { Subscription } from 'rxjs';
import { LayoutService, ScreenSize } from 'libs/portal/src/layout/layout.service';
import { Domains } from 'libs/portal/src/models/DomainInfo';
import { NavigationService } from 'libs/portal/src/services/navigation/navigation.service';
import { UserAccessRole, UserRightsService } from 'libs/portal/src/services/user-rights/user-rights.service';
import { Endpoints } from 'libs/portal/src/config';
import { Routes } from '@huge-monorepo/portal/config';
import { ConfirmationModalComponent } from '../../home/components/user/components/confirmation-modal/confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import { GenericService } from '@huge-monorepo/portal/services';
import { ToastrService } from 'ngx-toastr';
import { SharedGenericSingletonService } from '@huge-monorepo/shared/services';
import { CollapsedMenuComponent } from './components/collpased-menu/collapsed-menu.component';

@Component({
  selector: 'tools-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit, OnDestroy {
  @Input() menuItems: any = {};
  @Input() isOpen: boolean;

  @Output() CloseRequested: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() sizeChanged = new EventEmitter<void>();
  @ViewChildren('panel') _matExpansionPanel: any;

  ScreenSize = ScreenSize;
  modalStyle: string = this.layoutService.screenSize > this.ScreenSize.MOBILE_L ? 'auto-height' : '';
  appVersion: any = null;
  groupName: any = null;
  AccessObject: UserAccessRole | null;
  authSubscription: Subscription;
  lightMode = this.sharedGenericService.getIsLightMode();
  path = this.sharedGenericService.getPath();
  subIconPath = this.sharedGenericService.getPath(true);
  activeIndex: number | null;
  isCollapsed: boolean;
  modalOpen: boolean;

  constructor(
    private nav: NavigationService,
    private auth: UserRightsService,
    private routes: Routes,
    private layoutService: LayoutService,
    private endpoints: Endpoints,
    private dialog: MatDialog,
    private genericService: GenericService,
    private toastService: ToastrService,
    private sharedGenericService: SharedGenericSingletonService<ICustomerGenericService | IHIPGenericService>,
  ) {
    this.appVersion = this.endpoints.APP_VERSION;
    this.authSubscription = this.auth.GetUser().subscribe((user) => {
      if (user.isObfuscated) {
        this.groupName = 'Demo';
      } else {
        this.groupName = auth.GetGroupName();
      }
    });
  }
  ngOnDestroy(): void {
    this.authSubscription.unsubscribe();
  }

  ngOnInit() {
    this.AccessObject = this.auth.GetUserAccessRoles();
    if (this.AccessObject) {
      this.refreshSideNav();
      if (!this.menuItems) {
        this.buildSideNav();
      }
    }
    if (this.lightMode) {
      document.documentElement.style.setProperty('--indicator-color', '#07062D');
    } else {
      document.documentElement.style.setProperty('--indicator-color', 'white');
    }
  }

  refreshSideNav() {
    this.menuItems = this.nav.GetMenuItems();
    this.isCollapsed = this.nav.GetIsCollapsed();
    this.activeIndex = this.nav.GetActiveIndex();
  }

  buildSideNav() {
    const route = this.nav.GetCurrentRoute();
    const routeParts = route.split('/');
    this.buildPortalHome();
  }

  closeClicked() {
    this.CloseRequested.emit(true);
  }

  buildPortalHome() {
    this.menuItems = {
      title: '',
      link: this.routes.Home,
      icon: this.path + 'keyboard_double_arrow_left.png',
      parent: '',
      parentLink: '/',
      menuItems: [],
    };

    if (this.AccessObject?.HasCDRAccess() && this.auth.HasCDRAccess()) {
      this.menuItems['menuItems'].push({
        title: 'DATA USAGE',
        link: this.routes.CDR,
        customIcon: true,
        icon: this.path + 'data_usage_default.svg',
        subIcon: this.subIconPath + 'data_usage_default.svg',
        activeIcon: 'assets/navigation/active/data_usage_active.svg',
        menuItems: [
          {
            title: 'DASHBOARD',
            link: this.routes.CDRDashboard,
            customIcon: true,
            icon: this.path + 'dashboard_default.svg',
            subIcon: this.subIconPath + 'dashboard_default.svg',
            activeIcon: 'assets/navigation/active/dashboard_active.svg',
          },
          {
            title: 'DEVICES',
            link: this.routes.CDRDevices,
            customIcon: true,
            icon: this.path + 'devices_default.svg',
            subIcon: this.subIconPath + 'devices_default.svg',
            activeIcon: 'assets/navigation/active/devices_active.svg',
          },
          {
            title: 'ALERTS',
            link: this.routes.CDRAlerts,
            customIcon: true,
            icon: this.path + 'warning_default.svg',
            subIcon: this.subIconPath + 'warning_default.svg',
            activeIcon: 'assets/navigation/active/warning_active.svg',
          },
          {
            title: 'MAPS',
            link: this.routes.CDRMap,
            customIcon: true,
            icon: this.path + 'map_default.svg',
            subIcon: this.subIconPath + 'map_default.svg',
            activeIcon: 'assets/navigation/active/map_active.svg',
          },
        ],
      });
    }

    if (this.AccessObject?.HasKeepAliveAccess() && this.auth.HasKeepAliveAccess()) {
      const kaTypes = this.auth.GetKeepAliveTypes();
      let menuItemsKA = [
        {
          title: 'DASHBOARD',
          link: this.routes.KeepAliveDashboard,
          customIcon: true,
          icon: this.path + 'dashboard_default.svg',
          subIcon: this.subIconPath + 'dashboard_default.svg',
          activeIcon: 'assets/navigation/active/dashboard_active.svg',
        },
        {
          title: 'DEVICES',
          link: this.routes.KeepAliveDevices,
          customIcon: true,
          icon: this.path + 'devices_default.svg',
          subIcon: this.subIconPath + 'devices_default.svg',
          activeIcon: 'assets/navigation/active/devices_active.svg',
        },
      ]

      if (JSON.stringify(kaTypes) !== JSON.stringify(["tls"])) {
        menuItemsKA.push({
          title: 'MAPS',
          link: this.routes.KeepAliveMap,
          customIcon: true,
          icon: this.path + 'map_default.svg',
          subIcon: this.subIconPath + 'map_default.svg',
          activeIcon: 'assets/navigation/active/map_active.svg',
        },
          {
            title: 'RING-FENCE LOGS',
            link: this.routes.KeepAliveRingfenceLogs,
            customIcon: true,
            icon: this.path + 'warning_default.svg',
            subIcon: this.subIconPath + 'warning_default.svg',
            activeIcon: 'assets/navigation/active/warning_active.svg',
          },);
      }

      this.menuItems['menuItems'].push({
        title: 'KEEP ALIVE',
        link: this.routes.KeepAlive,
        customIcon: true,
        icon: this.path + 'keepalive_default.svg',
        subIcon: this.subIconPath + 'keepalive_default.svg',
        activeIcon: 'assets/navigation/active/keepalive_active.svg',
        menuItems: menuItemsKA,
      });

    }

    if (this.AccessObject?.HasMikrotikAccess() && this.auth.HasMikrotikAccess()) {
      this.menuItems['menuItems'].push({
        title: 'ROUTER MANAGEMENT',
        // link: this.routes.Mikrotik,         // Commented till dashboard has been built
        link: this.routes.Mikrotik,
        customIcon: true,
        icon: this.path + 'router_management_default.svg',
        subIcon: this.subIconPath + 'router_management_default.svg',
        activeIcon: 'assets/navigation/active/router_management_active.svg',
        menuItems: [
          {
            title: 'DASHBOARD',
            link: this.routes.MikrotikDashboard,
            customIcon: true,
            icon: this.path + 'dashboard_default.svg',
            subIcon: this.subIconPath + 'dashboard_default.svg',
            activeIcon: 'assets/navigation/active/dashboard_active.svg',
          },
          {
            title: 'DEVICES',
            link: this.routes.MikrotikDevices,
            customIcon: true,
            icon: this.path + 'devices_default.svg',
            subIcon: this.subIconPath + 'devices_default.svg',
            activeIcon: 'assets/navigation/active/devices_active.svg',
          },
          {
            title: 'MAPS',
            link: this.routes.MikrotikMap,
            customIcon: true,
            icon: this.path + 'map_default.svg',
            subIcon: this.subIconPath + 'map_default.svg',
            activeIcon: 'assets/navigation/active/map_active.svg',
          },
        ],
      });
    }

    if (this.AccessObject?.HasRelayAccess() && this.auth.HasRelayAccess()) {
      this.menuItems['menuItems'].push({
        title: 'TRANSACTION MONITORING',
        link: this.routes.Relay,
        customIcon: true,
        icon: this.path + 'transaction_monitoring_default.svg',
        subIcon: this.subIconPath + 'transaction_monitoring_default.svg',
        activeIcon: 'assets/navigation/active/transaction_monitoring_active.svg',
        menuItems: [
          {
            title: 'DASHBOARD',
            link: this.routes.RelayDashboard,
            customIcon: true,
            icon: this.path + 'dashboard_default.svg',
            subIcon: this.subIconPath + 'dashboard_default.svg',
            activeIcon: 'assets/navigation/active/dashboard_active.svg',
            menuItems: [],
          },
          {
            title: 'PORTS MANAGEMENT',
            link: this.routes.RelayPortsManagement,
            customIcon: true,
            icon: this.path + 'ports_management_default.svg',
            subIcon: this.subIconPath + 'ports_management_default.svg',
            activeIcon: 'assets/navigation/active/ports_management_active.svg',
            menuItems: [],
          },
        ],
      });
    }

    // Teltonika
    if (this.AccessObject?.HasTeltonikaAccess() && this.auth.HasTeltonikaAccess()) {
      this.menuItems['menuItems'].push({
        title: 'TELTONIKA',
        link: this.routes.Teltonika,
        icon: this.path + 'teltonika_default.svg',
        subIcon: this.subIconPath + 'teltonika_default.svg',
        activeIcon: 'assets/navigation/active/teltonika_active.svg',
        customIcon: true,
        menuItems: [
          {
            title: 'DASHBOARD',
            link: this.routes.TeltonikaDashboard,
            icon: this.path + 'dashboard_default.svg',
            subIcon: this.subIconPath + 'dashboard_default.svg',
            activeIcon: 'assets/navigation/active/dashboard_active.svg',
            customIcon: true,
          },
          ...(this.AccessObject.IsTeltonikaAdmin()) || this.AccessObject.IsReporting() ? [{
            title: 'REPORTING',
            link: this.routes.TeltonikaReporting,
            icon: this.path + 'reporting_default.svg',
            subIcon: this.subIconPath + 'reporting_default.svg',
            activeIcon: 'assets/navigation/active/reporting_active.svg',
            customIcon: true,
          }] : [],
        ],
      });
    }

    if (this.AccessObject?.IsReporting()) {
      this.menuItems['menuItems'].push({
        title: 'REPORTS',
        link: this.routes.Reports,
        customIcon: true,
        icon: this.path + 'reports_default.svg',
        subIcon: this.subIconPath + 'reports_default.svg',
        activeIcon: 'assets/navigation/active/reports_active.svg',
        menuItems: [],
      });
    }

    if (this.AccessObject?.IsSuperUser() && this.auth.GetUserPortalReadWrite().PortalWriteAccess) {
      this.menuItems['menuItems'].push(
        {
          title: 'System Admin',
          link: this.routes.SystemAdmin,
          customIcon: true,
          icon: this.path + 'system_admin_default.svg',
          subIcon: this.subIconPath + 'system_admin_default.svg',
          activeIcon: 'assets/navigation/active/system_admin_active.svg',
          menuItems: [],
        },
      );
    }

    if (this.AccessObject?.IsSuperUser()) {
      this.menuItems['menuItems'].push(
        {
          title: 'User Management',
          link: this.routes.UserManagement,
          customIcon: true,
          icon: this.path + 'user_management_default.svg',
          subIcon: this.subIconPath + 'user_management_default.svg',
          activeIcon: 'assets/navigation/active/user_management_active.svg',
          menuItems: [],
        },
      );
    }

    if (this.AccessObject?.HasContractorsAccess() && this.auth.HasContractorsAccess()) {
      this.menuItems['menuItems'].push(
        {
          title: 'Contractors',
          link: this.routes.Contractors,
          customIcon: true,
          icon: this.path + 'job_view_default.svg',
          subIcon: this.subIconPath + 'job_view_default.svg',
          activeIcon: 'assets/navigation/active/job_view_active.svg',
          menuItems: [],
        },
      );
    }
  }

  buildCDR() {
    // let baseURL = '/CDR';    // Commented till dashboard has been built
    // this.menuItems = {                 // Commented till dashboard has been built
    //   title: 'Router Management',
    //   link: baseURL,
    //   icon: 'local_activity',
    //   parent: 'Home',
    //   parentLink: this.routes.Home,
    //   menuItems: []
    // };

    this.menuItems = {
      title: 'DATA USAGE',
      link: this.routes.CDR,
      icon: this.path + 'data_usage_default.svg',
      subIcon: this.subIconPath + 'data_usage_default.svg',
      activeIcon: 'assets/navigation/active/data_usage_active.svg',
      parent: 'Home',
      parentLink: this.routes.Home,
      menuItems: [],
    };

    this.menuItems['menuItems'].push(
      {
        title: 'DASHBOARD',
        link: this.routes.CDRDashboard,
        customIcon: true,
        icon: this.path + 'dashboard_default.svg',
        subIcon: this.subIconPath + 'dashboard_default.svg',
        activeIcon: 'assets/navigation/active/dashboard_active.svg',
        menuItems: [],
      },
      // {
      //   title: 'Map',
      //   link: baseURL + '/Map',
      //   icon: 'analytics',
      //   menuItems: []
      // },
      {
        title: 'DEVICES',
        link: this.routes.CDRDevices,
        customIcon: true,
        icon: this.path + 'devices_default.svg',
        subIcon: this.subIconPath + 'devices_default.svg',
        activeIcon: 'assets/navigation/active/devices_active.svg',
        parent: 'Router Management',
        parentLink: this.routes.CDR,
        menuItems: [],
      },
      {
        title: 'ALERTS',
        link: this.routes.CDRAlerts,
        customIcon: true,
        icon: this.path + 'warning_default.svg',
        subIcon: this.subIconPath + 'warning_default.svg',
        activeIcon: 'assets/navigation/active/warning_active.svg',
        menuItems: [],
      },
      {
        title: 'MAPS',
        link: this.routes.CDRMap,
        customIcon: true,
        icon: this.path + 'map_default.svg',
        subIcon: this.subIconPath + 'map_default.svg',
        activeIcon: 'assets/navigation/active/map_active.svg',
        menuItems: [],
      },
      // {
      //   title: 'Reports',
      //   link: baseURL + '/Reports',
      //   icon: 'analytics',
      //   menuItems: []
      // },
    );
  }

  buildRelay() {
    this.menuItems = {
      title: 'TRANSACTION MONITORING',
      link: this.routes.Relay,
      icon: this.path + 'transaction_monitoring_default.svg',
      subIcon: this.subIconPath + 'transaction_monitoring_default.svg',
      activeIcon: 'assets/navigation/active/transaction_monitoring_active.svg',
      parent: 'Home',
      parentLink: this.routes.Home,
      menuItems: [],
    };

    this.menuItems['menuItems'].push({
      title: 'DASHBOARD',
      link: this.routes.RelayDashboard,
      customIcon: true,
      icon: this.path + 'dashboard_default.svg',
      subIcon: this.subIconPath + 'dashboard_default.svg',
      activeIcon: 'assets/navigation/active/dashboard_active.svg',
      menuItems: [],
    });

    this.menuItems['menuItems'].push({
      title: 'PORTS MANAGEMENT',
      link: this.routes.RelayPortsManagement,
      customIcon: true,
      icon: this.path + 'ports_management_default.svg',
      subIcon: this.subIconPath + 'ports_management_default.svg',
      activeIcon: 'assets/navigation/active/ports_management_active.svg',
      menuItems: [],
    });
  }

  buildKeepAlive() {
    const kaTypes = this.auth.GetKeepAliveTypes();
    this.menuItems = {
      title: 'KEEP ALIVE',
      link: this.routes.KeepAlive,
      icon: this.path + 'keepalive_default.svg',
      activeIcon: 'assets/navigation/active/keepalive_active.svg',
      parent: 'Home',
      parentLink: this.routes.Home,
      menuItems: [],
    };

    this.menuItems['menuItems'].push(
      {
        title: 'DASHBOARD',
        link: this.routes.KeepAliveDashboard,
        customIcon: true,
        icon: this.path + 'dashboard_default.svg',
        subIcon: this.subIconPath + 'dashboard_default.svg',
        activeIcon: 'assets/navigation/active/dashboard_active.svg',
        menuItems: [],
      },

      {
        title: 'DEVICES',
        link: this.routes.KeepAliveDevices,
        customIcon: true,
        icon: this.path + 'devices_default.svg',
        subIcon: this.subIconPath + 'devices_default.svg',
        activeIcon: 'assets/navigation/active/devices_active.svg',
        menuItems: [],
      },

    );
    if (JSON.stringify(kaTypes) !== JSON.stringify(["tls"])) {
      this.menuItems['menuItems'].push({
        title: 'MAPS',
        link: this.routes.KeepAliveMap,
        customIcon: true,
        icon: this.path + 'map_default.svg',
        activeIcon: 'assets/navigation/active/map_active.svg',
        menuItems: [],
      },
        {
          title: 'RING-FENCE LOGS',
          link: this.routes.KeepAliveRingfenceLogs,
          customIcon: true,
          icon: this.path + 'warning_default.svg',
          subIcon: this.subIconPath + 'warning_default.svg',
          activeIcon: 'assets/navigation/active/warning_active.svg',
          menuItems: [],
        },);
    }
  }

  buildMikrotik() {
    // let baseURL = '/Home/Mikrotik';    // Commented till dashboard has been built
    this.menuItems = {
      title: 'ROUTER MANAGEMENT',
      link: this.routes.Mikrotik,
      icon: this.path + 'router_management_default.svg',
      subIcon: this.subIconPath + 'router_management_default.svg',
      activeIcon: 'assets/navigation/active/router_management_active.svg',
      parent: 'Home',
      parentLink: this.routes.Home,
      menuItems: [],
    };

    this.menuItems['menuItems'].push(
      {
        title: 'DASHBOARD',
        link: this.routes.MikrotikDashboard,
        customIcon: true,
        icon: this.path + 'dashboard_default.svg',
        subIcon: this.subIconPath + 'dashboard_default.svg',
        activeIcon: 'assets/navigation/active/dashboard_active.svg',
        menuItems: [],
      },
      {
        title: 'DEVICES',
        link: this.routes.MikrotikDevices,
        customIcon: true,
        icon: this.path + 'devices_default.svg',
        subIcon: this.subIconPath + 'devices_default.svg',
        activeIcon: 'assets/navigation/active/devices_active.svg',
        menuItems: [],
      },
      {
        title: 'MAPS',
        link: this.routes.MikrotikMap,
        customIcon: true,
        icon: this.path + 'map_default.svg',
        subIcon: this.subIconPath + 'map_default.svg',
        activeIcon: 'assets/navigation/active/map_active.svg',
        menuItems: [],
      },
    );
  }

  async logout() {
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      data: {
        confimationMessage: 'Are you sure that you would like to logout?',
      },
      panelClass: this.modalStyle,
    });

    let dialogSub = dialogRef.afterClosed().subscribe({
      next: (dataReturned) => {
        if (dataReturned) {
          this.genericService.GET(this.endpoints.LOGOUT).subscribe(
            (res) => {
              this.auth.Logout();
              this.toastService.success('', (res as any).body, { timeOut: 2000 });
            },
            () => {
              this.auth.Logout();
            },
          );
        }
        dialogSub.unsubscribe();
      },
    });
  }

  buildTeltonika() {
    this.menuItems = {
      title: 'TELTONIKA',
      icon: 'bulk emailer', // TODO: Get an icon for teltonika
      link: '/Teltonika/Dashboard',
      parent: 'Home',
      parentLink: this.routes.Home,
      menuItems: [
        {
          title: 'DASHBOARD',
          link: this.routes.TeltonikaDashboard,
          icon: this.path + 'dashboard_default.svg',
          subIcon: this.subIconPath + 'dashboard_default.svg',
          activeIcon: 'assets/navigation/active/dashboard_active.svg',
          customIcon: true,
          menuItems: [],
        },
        {
          title: 'REPORTING',
          link: this.routes.TeltonikaReporting,
          icon: this.path + 'reporting_default.svg',
          subIcon: this.subIconPath + 'reporting_default.svg',
          activeIcon: 'assets/navigation/active/reporting_active.svg',
          customIcon: true,
          menuItems: [],
        },
      ],
    };
  }

  expandPanel(event: any, index: number): void {
    event.stopPropagation(); // Prevent event bubbling

    if (this._matExpansionPanel._results && this._matExpansionPanel._results[index]) {
      const panel = this._matExpansionPanel._results[index];

      // Properly toggle the panel
      panel.expanded = !panel.expanded;

      // Optionally close other panels if needed
      if (panel.expanded) {
        this._matExpansionPanel._results.forEach((p, i) => {
          if (i !== index) p.expanded = false;
        });
      }
    }
  }

  toggleActive(index: number, openSubMenu: boolean, event: MouseEvent): void {
    if (this.activeIndex !== index) {
      this.activeIndex = index;
      this.nav.SetActiveIndex(this.activeIndex);
    }

    if (openSubMenu) {
      const clickedPanel = event.target as HTMLElement;
      const rect = clickedPanel.getBoundingClientRect();
      this.openCollapsedMenuModal(index, rect);
    }
  }

  toggleIsCollapsed() {
    this.isCollapsed = !this.isCollapsed;
    this.nav.SetIsCollapsed(this.isCollapsed);
    this.sizeChanged.emit();
    if (this.isCollapsed) {
      this.menuItems['menuItems'].forEach(item => {
        item.Open = false;
      });
    }
  }

  updateMainMenuItemState(mainMenuItem: any): boolean {
    return mainMenuItem.menuItems?.some((subMenuItem: any) => subMenuItem.active);
  }

  navigateTo(url: string | null, mainMenuItem?: any, subMenuItem?: any, queryParams?: any) {
    if (!url) {
      return;
    }
    this.nav.deactivateMenuItems();
    if(mainMenuItem && mainMenuItem.menuItems && subMenuItem) {
      mainMenuItem.Open = true;
      mainMenuItem.menuItems.forEach((item: any) => {
        item.active = false;
      });
      subMenuItem.active = true;
    } else if (mainMenuItem) {
      mainMenuItem.active = true;
    }
    this.nav.SetMenuItems(this.menuItems);
    this.nav.SetActiveIndex(this.activeIndex);
    this.nav.SetIsCollapsed(this.isCollapsed);
    this.nav.Navigate(url, queryParams);
  }

  async openCollapsedMenuModal(index: number, rect: DOMRect): Promise<void> {
    this.nav.SetMenuItems(this.menuItems);

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden'; // Disable scrolling on html
    this.menuItems['menuItems'][index].subOpen = true;
    const dialogRef = this.dialog.open(CollapsedMenuComponent, {
      position: { top: `${rect.top}px`, left: "76px" },
      width: "218px",
      data: { menuItems: this.menuItems['menuItems'][index], i: index },
      panelClass: 'nav-dialog'
    });

    dialogRef.componentInstance.deactivateItems.subscribe(() => {
      this.nav.deactivateMenuItems();
    });

    dialogRef.componentInstance.navigationOccurred.subscribe(() => {
      this.refreshSideNav();  // Call the refresh function when navigation occurs
    });

    // When the dialog closes, re-enable scrolling
    dialogRef.afterClosed().subscribe(() => {
      this.menuItems['menuItems'][index].subOpen = false;
      document.body.style.overflow = ''; // Restore body scroll
      document.documentElement.style.overflow = '';
    });
  }
}
